var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h4"},[_vm._v(" "+_vm._s(_vm.getSnippet(_vm.field.label))+" "),(_vm.field.help)?_c('i',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.helpText),expression:"helpText",modifiers:{"hover":true,"top":true}}],staticClass:"fal fa-circle-info text-hover-primary ml-1"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }